import script from "./UCheckSMS.vue?vue&type=script&setup=true&lang=ts"
export * from "./UCheckSMS.vue?vue&type=script&setup=true&lang=ts"

import "./UCheckSMS.vue?vue&type=style&index=0&id=63aedaa6&lang=css"

const __exports__ = script;

export default __exports__